export default "<div\n  class=\"chip\"\n  [ngClass]=\"type\"\n>\n  <ng-content></ng-content>\n</div>\n";